import React from 'react';
import { Field, useFormikContext } from 'formik';
import { FormattedMessage } from 'react-intl';
import { DropdownComponent } from '../../../../../components/prime-formik';

const SuperProfileInput = ({ jobProfiles }) => {
  const { setFieldValue } = useFormikContext();

  const jobProfileOptions = jobProfiles.map((jobProfile) => {
    return {
      label: jobProfile.name,
      value: jobProfile.id,
    };
  });

  return (
    <div className="p-col-12">
      <div className="margin-bottom-0-5">
        <FormattedMessage
          id="account.super-profiles.new.job-profile.label"
          defaultMessage="Match candidates against this Job Profile"
        >
          {(text) => (
            <label className="field-label" htmlFor="jobProfileId">
              <strong>{text}</strong>
            </label>
          )}
        </FormattedMessage>
      </div>
      <div className="flex-space-between">
        <FormattedMessage
          id="account.super-profiles.new.job-profile.placeholder"
          defaultMessage="Select an existing Job Profile"
        >
          {(text) => (
            <label className="field-label" htmlFor="jobProfileId">
              {text}
            </label>
          )}
        </FormattedMessage>
        <FormattedMessage id="select" defaultMessage="Select">
          {(text) => (
            <Field
              id="jobProfileId"
              name="jobProfileId"
              component={DropdownComponent}
              options={jobProfileOptions}
              filter
              filterBy="label,value"
              className="right"
              onChange={(event) => {
                setFieldValue('jobProfileId', event.value);
              }}
              placeholder={`-- ${text} --`}
            />
          )}
        </FormattedMessage>
      </div>
    </div>
  );
};

export default SuperProfileInput;
